import React, { useState } from "react";
import DropdownMenu from "./DropdownMenu";
import moreIcon from "../assets/icon_more.svg";
import caretDown from "../assets/icon-arrow-down.svg";
import caretUp from "../assets/icon-arrow-up.svg";
import { ALL_PROJECTS_ID } from "../constants/projects";

// Split-action project chip, mirroring Android's ProjectChip:
//   [  Project Name  ▾ | ⋯  ]
// Left zone (name + caret) opens a dropdown of "All Projects" + every project to
// switch to; right zone (⋯) opens the project-actions menu. A hairline divider
// separates the two hit zones.
const ProjectChip = ({ projects, activeProject, onProjectChange, actionItems }) => {
  const [pickerOpen, setPickerOpen] = useState(false);
  const activeName = activeProject ? activeProject.projectName : "All Projects";
  const activeId = activeProject ? String(activeProject.id) : "";

  const select = (id) => {
    setPickerOpen(false);
    onProjectChange(id);
  };

  return (
    <div style={styles.chip}>
      {/* Left zone: name + caret → project picker */}
      <div style={styles.leftWrap}>
        <button style={styles.leftZone} onClick={() => setPickerOpen((o) => !o)}>
          <span style={styles.name}>{activeName}</span>
          <img
            src={pickerOpen ? caretUp : caretDown}
            alt=""
            style={styles.caret}
          />
        </button>
        {pickerOpen && (
          <>
            <div style={styles.overlay} onClick={() => setPickerOpen(false)} />
            <div style={styles.menu}>
              <div
                style={{
                  ...styles.item,
                  ...(activeId === "" ? styles.itemSelected : {}),
                }}
                onClick={() => select(ALL_PROJECTS_ID)}
              >
                All Projects
              </div>
              {projects.map((p) => (
                <div
                  key={p.id}
                  style={{
                    ...styles.item,
                    ...(activeId === String(p.id) ? styles.itemSelected : {}),
                  }}
                  onClick={() => select(p.id)}
                >
                  {p.projectName}
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Hairline divider */}
      <div style={styles.divider} />

      {/* Right zone: ⋯ → actions menu */}
      <div style={styles.rightZone}>
        <DropdownMenu icon={moreIcon} menuItems={actionItems} alignRight />
      </div>
    </div>
  );
};

const styles = {
  chip: {
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: "var(--surface)",
    borderRadius: "12px",
    border: "1px solid var(--border)",
    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.25)",
    height: "34px",
  },
  leftWrap: { position: "relative", display: "flex", alignItems: "center" },
  leftZone: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "0 10px 0 14px",
    height: "100%",
    color: "var(--text)",
  },
  name: {
    fontSize: "14px",
    fontWeight: 500,
    color: "var(--text)",
    maxWidth: "160px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  caret: { width: "16px", height: "16px", filter: "var(--icon-filter)" },
  divider: {
    width: "1px",
    height: "16px",
    backgroundColor: "var(--border)",
  },
  rightZone: {
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
  },
  overlay: { position: "fixed", inset: 0, zIndex: 1000 },
  menu: {
    position: "absolute",
    top: "calc(100% + 6px)",
    right: 0,
    backgroundColor: "var(--surface)",
    border: "1px solid var(--border)",
    borderRadius: "8px",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.3)",
    zIndex: 1001,
    minWidth: "200px",
    maxWidth: "240px",
    padding: "4px",
    maxHeight: "320px",
    overflowY: "auto",
  },
  item: {
    padding: "10px 12px",
    cursor: "pointer",
    fontSize: "14px",
    color: "var(--text)",
    borderRadius: "6px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  itemSelected: { color: "var(--primary)", fontWeight: 600 },
};

export default ProjectChip;
